<template>
  <simple-image-page
    page-label="לתת את רייזאפ במתנה 🎁"
     :img-src="require('@/assets/riseup-giftcard/header_gift.svg')"
     title="רייזאפ גיפט קארד: להעניק עתיד כלכלי טוב יותר, במתנה."
     :button-props="buttonProps">
    <template v-slot:textSlot>
      <div>
        <div> הגיפטקארד שלנו מאפשר לך לתת במתנה, למי שחשוב לך, שישה חודשים ברייזאפ ללא תשלום! </div>
        <div> <b>לך זה יעלה 180 ₪, במקום 225 ₪,</b> ולצד השני זה יהיה שווה הרבה הרבה יותר 💪 </div>
        <callout icon-path="icons/heart-icon.svg" title="הידעת?" class="callout">
          <template v-slot:text>
            <div>
              בממוצע לקוחות רייזאפ משפרים את התזרים החודשי שלהם
              <span class="bold">ב-2,473 ₪</span>
              תוך שלושה חודשים
            </div>
            <span></span>
          </template>
        </callout>

        <div class="new-customers"> ההטבה ניתנת למימוש ללקוחות חדשים בלבד. </div>
      </div>
    </template>
  </simple-image-page>
</template>

<script>
import Segment from '@/Segment';
import SimpleImagePage from '@/base-components/SimpleImagePage';
import BaseUI from 'base-ui';

export default {
  name: 'GiftcardWelcome',
  components: {
    SimpleImagePage,
    Callout: BaseUI.Callout,
  },
  created() {
    Segment.trackUserInteraction('RiseupGiftcard_Entered');
  },
  methods: {
    buttonAction() {
      Segment.trackUserInteraction('RiseupGiftcard_NextClicked');
      this.$emit('clicked');
    },
  },
  computed: {
    buttonProps() {
      return {
        title: 'בואו נקנה את השובר 🎁',
        action: this.buttonAction,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.new-customers {
  padding-top: 10px;
}

.bold {
  font-weight: bold;
}

.callout {
  margin-top: 25px;
}
</style>
